var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "operations" } },
    [
      _c("OperationsBreadcrumb", { attrs: { links: _vm.links } }),
      _vm.$i18n.locale === "pe"
        ? _c(
            "div",
            [
              _c("Message", {
                attrs: {
                  message: "",
                  icon: "coming_soon_cl.svg",
                  "as-card": true,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.isI18n & (_vm.$i18n.locale === "cl" || _vm.$i18n.locale === "br")
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "card-item mt-6" },
                [
                  _vm.isLoading ? _c("Spinner") : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "operations-header mb-2" },
                    [
                      !_vm.isLoading
                        ? _c("OperationsButtons", {
                            attrs: { hide: true, "is-upload-active": "true" },
                            on: {
                              refresh: function ($event) {
                                return _vm.getSummaryOperationsByType()
                              },
                            },
                          })
                        : _vm._e(),
                      !_vm.isLoading && _vm.$i18n.locale === "br"
                        ? _c(
                            "b-tag",
                            {
                              attrs: {
                                icon: "circle-check",
                                type: "is-light is-warning",
                                rounded: "",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.verifiedOperations.length) +
                                  " " +
                                  _vm._s(
                                    _vm.verifiedOperations.length > 1
                                      ? "operações"
                                      : "operação"
                                  ) +
                                  " verificada" +
                                  _vm._s(
                                    _vm.verifiedOperations.length > 1 ? "s" : ""
                                  ) +
                                  " de " +
                                  _vm._s(_vm.summaryOperation.length) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  !_vm.isLoading
                    ? _c(
                        "b-table",
                        {
                          attrs: {
                            data: _vm.summaryOperation,
                            paginated: _vm.isPaginated,
                            "per-page": _vm.perPage,
                          },
                        },
                        [
                          _c("b-table-column", {
                            attrs: {
                              field: "clientName",
                              label: _vm.$t("clientName"),
                              searchable: "",
                              sortable: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (props) {
                                    return [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            id: `client-name-${props.row.idNumber}`,
                                            disabled: !_vm.checkUserFeature(
                                              "element.operations.button.view-operation"
                                            ),
                                            type: "is-primary is-light is-size-6",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.clickedOnOperation(
                                                props.row._id,
                                                props.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(props.row.clientName) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              11562359
                            ),
                          }),
                          _c("b-table-column", {
                            attrs: {
                              field: "idNumber",
                              label: _vm.$t("idNumber"),
                              searchable: "",
                              sortable: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (props) {
                                    return [
                                      _vm._v(
                                        " " + _vm._s(props.row.idNumber) + " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1451830291
                            ),
                          }),
                          _c("b-table-column", {
                            attrs: {
                              field: "companyOperationId",
                              label: _vm.$t("companyOperationId"),
                              searchable: "",
                              sortable: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (props) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(props.row.companyOperationId) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              338491042
                            ),
                          }),
                          _c("b-table-column", {
                            attrs: {
                              field: "type",
                              label: _vm.$t("type"),
                              searchable: "",
                              sortable: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (props) {
                                    return [
                                      _vm._v(
                                        " " + _vm._s(props.row.type) + " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1218402693
                            ),
                          }),
                          _c("b-table-column", {
                            attrs: {
                              field: "approvedAmount",
                              label: _vm.$t("approvedAmount"),
                              searchable: "",
                              sortable: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (props) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(props.row.approvedAmount) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1073840634
                            ),
                          }),
                          _c("b-table-column", {
                            attrs: {
                              field: "investor",
                              label: _vm.$t("investor"),
                              searchable: "",
                              sortable: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (props) {
                                    return [
                                      _vm._v(
                                        " " + _vm._s(props.row.investor) + " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2707579635
                            ),
                          }),
                          _c("b-table-column", {
                            attrs: {
                              field: "termAsMonths",
                              label: _vm.$t("termAsMonths"),
                              sortable: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (props) {
                                    return [
                                      _c(
                                        "b-progress",
                                        {
                                          attrs: {
                                            value:
                                              props.row.paymentsMade ===
                                              undefined
                                                ? 0
                                                : props.row.paymentsMade,
                                            type: "is-primary",
                                            size: "is-medium",
                                            max: props.row.termAsMonths,
                                            "show-value": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "payments-progress",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  props.row.paymentsMade ===
                                                    undefined
                                                    ? "0"
                                                    : props.row.paymentsMade
                                                ) +
                                                  " / " +
                                                  _vm._s(props.row.termAsMonths)
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2006910528
                            ),
                          }),
                          _c("b-table-column", {
                            attrs: {
                              field: "isActive",
                              label: _vm.$t("isActive"),
                              sortable: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (props) {
                                    return [
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "b-field",
                                            {
                                              staticClass:
                                                "is-flex is-align-items-center",
                                            },
                                            [
                                              _c("b-switch", {
                                                attrs: {
                                                  disabled:
                                                    !_vm.checkUserFeature(
                                                      "element.operations.switch.deactivate-operation"
                                                    ),
                                                  value: props.row.isActive,
                                                  size: "is-small",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.clickedOnDeactivateOperation(
                                                      props.row._id
                                                    )
                                                  },
                                                },
                                              }),
                                              props.row.isVerified
                                                ? _c("i", {
                                                    staticClass:
                                                      "has-text-primary fa-regular fa-circle-check",
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2799138603
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("OperationDeactivateConfirmModal", {
                attrs: {
                  operation: _vm.selectedOperation,
                  "state-user": _vm.stateUser,
                  "is-component-modal-active": _vm.isComponentModalActive,
                },
                on: {
                  process: _vm.clickedOnProcessDeactivateOperation,
                  cancelProcess: _vm.cancelProcess,
                },
              }),
              _c("OperationDeactivateResultModal", {
                attrs: {
                  operation: _vm.selectedOperation,
                  result: _vm.deactivateResult,
                  "is-component-modal-active": _vm.isComponentResultModalActive,
                },
                on: { cancelProcess: _vm.cancelProcess },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }